export default {
  tabs: {
    campaignInformation: 'Campaign information',
    otherInformation: 'Advanced settings',
    audience: 'Audience',
    campaignIdeas: 'Viral ideas',
  }
};
